import { useEffect } from "react";

type UseBeforeUnloadArgs = {
  enabled: boolean;
  message: string;
};

/**
 * ページ離脱確認ダイアログを表示する(リロードやタブ/ウィンドウの閉鎖等)
 * 主要ブラウザでは固定メッセージになります
 * @param enabled 離脱確認を有効化するかどうか
 * @param message 離脱確認時に設定するメッセージ
 */
export const useBeforeUnload = ({ enabled, message }: UseBeforeUnloadArgs) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [enabled, message]);
};
